export const PLATFORM_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [1]: '阿里云平台',
  [2]: '创蓝平台',
  [3]: '云浪无迹短信平台'
}

export const platformOptions = [
  {
    value: 1,
    label: '阿里云平台'
  },
  {
    value: 2,
    label: '创蓝短信平台'
  },
  {
    value: 3,
    label: '云浪无迹短信平台'
  }
]

export const tableDataSchemas = [
  {
    prop: 'appName',
    label: '短信接入方名称',
    minWidth: 120
  },
  {
    prop: 'accessKeySecret',
    label: '访问密钥value',
    minWidth: 120
  },
  {
    prop: 'platform',
    label: '平台',
    minWidth: 120
  },
  {
    prop: 'remark',
    label: '备注',
    minWidth: 120
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'appName',
    defaultValue: '',
    component: 'Input',
    label: '短信接入方名称',
    placeholder: '请输入短信接入方名称',
    rules: [
      {
        required: true,
        message: '短信接入方名称不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'platform',
    defaultValue: 1,
    component: 'Radio',
    label: '短信平台',
    placeholder: '请输入短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: 1
      },
      {
        value: 2,
        label: '创蓝短信平台'
      },
      {
        value: 3,
        label: '云浪无迹短信平台'
      }
    ]
  },
  {
    field: 'accessKeyId',
    defaultValue: '',
    component: 'Input',
    label: '平台访问密钥key',
    placeholder: '请输入平台访问密钥key',
    rules: [
      {
        required: true,
        message: '平台访问密钥key不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'accessKeySecret',
    defaultValue: '',
    component: 'Input',
    label: '平台访问密钥value',
    placeholder: '请输入平台访问密钥value',
    rules: [
      {
        required: true,
        message: '平台访问密钥value不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'tenantId',
    defaultValue: '',
    component: 'SelectSearch',
    label: '租户',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '备注',
    placeholder: '请输入备注',
    rules: [],
    trigger: ['blur']
  }
]

export const clFormSchemas = [
  {
    field: 'appName',
    defaultValue: '',
    component: 'Input',
    label: '短信接入方名称',
    placeholder: '请输入短信接入方名称',
    rules: [
      {
        required: true,
        message: '短信接入方名称不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'platform',
    defaultValue: 1,
    component: 'Radio',
    label: '短信平台',
    placeholder: '请输入短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: 1
      },
      {
        value: 2,
        label: '创蓝短信平台'
      },
      {
        value: 3,
        label: '云浪无迹短信平台'
      }
    ]
  },
  {
    field: 'needReplySms',
    defaultValue: 0,
    component: 'Radio',
    label: '短信回复通知',
    placeholder: '请选择',
    radioArr: [
      {
        label: '是',
        value: 1
      },
      {
        value: 0,
        label: '否'
      }
    ]
  },
  {
    field: 'isSubAccount',
    defaultValue: 1,
    component: 'Radio',
    label: '是否子账号',
    placeholder: '请选择',
    radioArr: [
      {
        label: '是',
        value: 1
      },
      {
        value: 0,
        label: '否'
      }
    ]
  },
  {
    field: 'subId',
    defaultValue: '',
    component: 'Input',
    label: '子账号ID',
    placeholder: '请输入',
    rules: [
      {
        required: true,
        message: '请输入子账号Id'
      }
    ]
  },
  {
    field: 'accessKeyId',
    defaultValue: '',
    component: 'Input',
    label: '平台访问密钥key',
    placeholder: '请输入平台访问密钥key,例：N123456',
    rules: [
      {
        required: true,
        message: '平台访问密钥key不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'accessKeySecret',
    defaultValue: '',
    component: 'Input',
    label: '平台访问密钥value',
    placeholder: '请输入平台访问密钥value,例：xxxxxxxxxx',
    rules: [
      {
        required: true,
        message: '平台访问密钥value不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'marketUserName',
    defaultValue: '',
    component: 'Input',
    label: '营销账号',
    placeholder: '请输入营销账号,例：1234567',
    rules: [

    ]
  },
  {
    field: 'marketPassword',
    defaultValue: '',
    component: 'Input',
    label: '营销密码',
    placeholder: '请输入营销密码,例：1234567',
    rules: [

    ]
  },
  {
    field: 'userName',
    defaultValue: '',
    component: 'Input',
    label: '用户名',
    placeholder: '请输入用户名,例：1234567',
    rules: [
      {
        required: true,
        message: '用户名不能为空'
      }
    ]
  },
  {
    field: 'password',
    defaultValue: '',
    component: 'Input',
    label: '密码',
    placeholder: '请输入密码,例：1234567',
    rules: [
      {
        required: true,
        message: '密码不能为空'
      }
    ]
  },
  {
    field: 'tenantId',
    defaultValue: '',
    component: 'SelectSearch',
    label: '租户',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '备注',
    placeholder: '请输入备注',
    rules: [],
    trigger: ['blur']
  }
]
